<template>
  <div class="toggle-container">
    <!-- 触发按钮插槽，默认显示一个按钮 -->
    <div class="trigger" @click="toggle">
      <slot name="trigger">
        <p class="flex items-center">
          <span>深度思考</span>&nbsp;
          <i
            class="pointer"
            :class="isVisible ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
          ></i>
        </p>
      </slot>
    </div>

    <!-- 内容区域，使用v-show实现显示隐藏 -->
    <div v-show="isVisible" class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToggleComponent',
  props: {
    // 控制默认是否显示
    defaultVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isVisible: this.defaultVisible,
    };
  },
  methods: {
    toggle() {
      this.isVisible = !this.isVisible;
      // 可选：触发状态变化事件
      this.$emit('toggle', this.isVisible);
    },
  },
  // 如果希望响应外部prop变化（可选）
  watch: {
    defaultVisible(newVal) {
      this.isVisible = newVal;
    },
  },
};
</script>

<style scoped lang="less">
.toggle-container {
  display: inline-block;
  width: 100%;
}

.trigger {
  color: #999999;
  font-size: 14px;
  height: 25px;
  line-height: 25px;
  user-select: none;

  p {
    width: 100px;
    cursor: pointer;

    &:hover {
      color: #333333;
    }
  }
}
</style>
